export const VARIABLE_GROUPS = ['recipient', 'deal', 'links', 'custom'] as const;

export type VariableGroup = (typeof VARIABLE_GROUPS)[number];

export interface VariableGroupEntry {
	group: VariableGroup;
	variables: string[];
}

const RECIPIENT_VARIABLES = new Set([
	'first_name',
	'last_name',
	'investor_full_name',
	'signatory_name',
	'piv_signer_first_name',
]);

const CUSTOM_VARIABLES = new Set(['custom_text']);

export const getVariableGroup = (name: string): VariableGroup => {
	if (RECIPIENT_VARIABLES.has(name)) {
		return 'recipient';
	}
	if (CUSTOM_VARIABLES.has(name)) {
		return 'custom';
	}
	if (name.endsWith('_url') || name === 'link') {
		return 'links';
	}
	return 'deal';
};

export const groupVariables = (names: string[]): VariableGroupEntry[] =>
	VARIABLE_GROUPS.map((group) => ({
		group,
		variables: names.filter((name) => getVariableGroup(name) === group),
	})).filter((entry) => entry.variables.length > 0);
